import { render, staticRenderFns } from "./ProductEntry.vue?vue&type=template&id=2b0abcc0&scoped=true"
import script from "./ProductEntry.vue?vue&type=script&lang=js"
export * from "./ProductEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0abcc0",
  null
  
)

export default component.exports